import { useMemo } from 'react';
import { ChatShort } from '../common/ai-chat/aiChatTypes';

type ChatSection<T extends ChatShort> = {
  title: string;
  items: T[];
  isCollapsible?: boolean;
};

export function useChatSections<T extends ChatShort>(chats?: T[]) {
  const [pinnedChats, recentChats] = useMemo(() => {
    const pinnedChats: T[] = [];
    const recentChats: T[] = [];

    chats?.forEach((chat) => {
      if (chat.isFavorite) {
        pinnedChats.push(chat);
      } else {
        recentChats.push(chat);
      }
    });
    return [pinnedChats, recentChats];
  }, [chats]);

  const sections: ChatSection<T>[] = useMemo(() => {
    return [
      { title: 'Starred', items: pinnedChats, isCollapsible: false },
      { title: 'Recent', items: recentChats, isCollapsible: false },
    ];
  }, [pinnedChats, recentChats]);

  return sections;
}
